import { render, staticRenderFns } from "./addOwnerRepair.vue?vue&type=template&id=20fece17"
import script from "./addOwnerRepair.vue?vue&type=script&lang=js"
export * from "./addOwnerRepair.vue?vue&type=script&lang=js"
import style0 from "./addOwnerRepair.vue?vue&type=style&index=0&id=20fece17&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports